require('./bootstrap');
require('./mrare/index.js');

(function ($) {
  $(function () {
    $('body').addClass(common.getCurrentBrowser())
  })

  window.Parsley.addValidator('matchto', {
    requirementType: 'string',
    validateString: function (value, requirement) {
      return value.toLowerCase() == $(requirement).val().toLowerCase()
    },
    messages: {
      en: 'Values must match',
    },
  })
})(jQuery)
